// extracted by mini-css-extract-plugin
export default {"antiScroll":"styles_antiScroll__7jKfI","header":"styles_header__j+I-u","moveToLocationWrapper":"styles_moveToLocationWrapper__PLTlf","alignIcon":"styles_alignIcon__l25or"};